<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="d-flex flex-column flex-md-row">
            <div class="col-12 col-md-2 p-0 m-0">
              <bita-bootbutton
                v-if="this.$acl.isSuperAdmin || $acl.can('create', 'users')"
                type="primary"
                title="کاربر جدید"
                icon="fas fa-plus-square"
                class="w-100"
                @click.native="statusChangeModalCreate"
              />
            </div>
            <div class="col-12 col-md-2 p-0 m-0 mx-0 mx-md-2 my-2 my-md-0">
              <bita-bootbutton
                icon="fas fa-filter"
                type="success"
                title="فیلتر بیشتر"
                @click.native="toggleFilters"
                class="w-100"
              />
            </div>
          </div>
          <div style="text-align: center; margin-bottom: 20px">
            <transition name="fade">
              <div v-show="showFilters">
                <hr />
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">
                      <bita-input
                        type="text"
                        name="search"
                        label="جستجو"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.search"
                        @change="(e) => userSearch(e)"
                        subtitle="جستجو بر اساس نام - نام خانوادگی - نام کاربری"
                      />
                      <bita-input
                        type="text"
                        name="national_code"
                        label="کدملی راننده"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.national_code"
                        @change="(e) => userSearch(e)"
                        subtitle="جستجو فقط با کد‌ملی کامل و صحیح"
                      />
                      <bita-input
                        type="text"
                        name="mobile"
                        label="شماره موبایل"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.phone"
                        @change="(e) => userSearch(e)"
                      />
                      <!-- <bita-select
                        name="type"
                        label="نوع کاربر"
                        ref="typeDropDown"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="types"
                        data-text-field="name"
                        data-value-field="type"
                        v-model="filters.type"
                        @change="(e) => userSearch(e)"
                      /> -->
                      <bita-select
                        name="status"
                        label="وضعیت"
                        ref="statusDropDown"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="statuses"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filters.is_active"
                        @change="(e) => userSearch(e)"
                      />
                    </div>
                  </div>
                </bita-form>
              </div>
            </transition>
          </div>
          <hr />
          <div class="table-responsive">
            <bita-grid
              ref="grid"
              :columns="gridColumns"
              :read-data="readData"
              :grid-server-side="true"
              :schema-total="'total'"
              :schema-data="'data'"
              :server-paging="true"
              :batch="true"
              :resizable="true"
              :page-size="pageSize"
              :current-page="currentPage"
              :howRow="true"
            />
          </div>
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :props-users="users"
      :entities="entities"
      modal-id="edit-modal"
      title="ویرایش کاربر"
      @on-submit="handleEdit"
      @change-model-type="(e) => onEntitiesChange(e)"
    />
    <form-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      :props-data="createForm"
      :props-users="users"
      :entities="entities"
      modal-id="create-modal"
      title="کاربر جدید"
      @on-submit="handleCreate"
      @change-model-type="(e) => onEntitiesChange(e)"
    />
    <form-role
      ref="editRole"
      :isLoading="isLoadingModal"
      :props-data="roleData"
      :props-roles="roles"
      modal-id="edit-role"
      @on-submit="handleEditRole"
    />
<password-modal
  ref="password"
  :isLoading="isLoadingModal"
  :propsUser="selectedUser"   
  modal-id="password-modal"
  title="تغییر رمز"
    @on-submit="changePassword"

/>

    <assistant-modal
      ref="assistant"
      :isLoading="isLoadingModal"
      :props-data="owner"
      modal-id="assistant-modal"
      title="اضافه کردن زیر مجموعه"
    />

    <salons-modal modal-id="salons-modal" :props-driver="propsDriver" />

    <!-- Actions -->
    <g-context-menu ref="contextMenu" #default="{items: user}">
      <g-list>
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('update', 'users')"
          title="ویرایش کاربر"
          icon="fas fa-pen-square"
          @click="edit(user)"
        />
        <template v-if="user.model && user.model.documents_file">
          <g-list-item
            title="دانلود اسناد"
            icon="fas fa-download"
            @click="handleDownloadDocuments(user.model.documents_file)"
          />
        </template>
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('update', 'users')"
          title="تغییر وضعیت"
          icon="fas fa-lock"
          @click="status(user)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('update', 'userroles')"
          title="مشاهده سطح دسترسی"
          icon="fas fa-shield-alt"
          @click="roleEdit(user)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('edit', 'usersalons')"
          title="سالن ها"
          icon="fas fa-sort"
          @click="salonsOfUser(user)"
        />
        <g-list-item
          title="اضافه کردن زیر مجموعه"
          icon="fas fa-user-plus"
          @click="assistant(user)"
        />
        <g-list-item
          title="تغییر رمز عبور"
          icon="fas fa-key"
          @click="openPasswordModal(user)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('delete', 'users')"
          title="پایان نشست کاربر"
          icon="fas fa-user"
          @click="expireToken(user)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('delete', 'users')"
          title="حذف کاربر"
          icon="fas fa-times"
          @click="deleteUser(user)"
        />
      </g-list>
    </g-context-menu>
  </div>
</template>
<script>
import UsersForm from "./From";
import UserRole from "./Role";
import SalonsForm from "./SalonsForm.vue";
import PasswordForm from "./PasswordForm.vue";
import AssistantForm from "./components/AssistantForm.vue";
import GContextMenu from "../../../components/GContextMenu.vue";
import GList from "../../../components/listItem/GList.vue";
import GListItem from "../../../components/listItem/GListItem.vue";

export default {
  components: {
    "form-modal": UsersForm,
    "form-role": UserRole,
    "salons-modal": SalonsForm,
    "password-modal": PasswordForm,
    "assistant-modal": AssistantForm,
    GContextMenu,
    GList,
    GListItem,
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت کاربران",
          link: "/management/users",
          active: true,
        },
      ],
      propsDriver: {},
      users: [],
      state: [],
      isCarrier_test: false,
      citiesOrgin: [],
      citiesDestination: [],
      loads: [],
      vehicleTypes: [],
      entities: [],
      roles: [],
      owner: {},
      isLoadingGrid: false,
      isLoadingModal: false,
      roleData: {},
      createForm: {},
      updateForm: {},
      showFilters: false,
      selectedUser: {},

      filters: {
        none_type: "Driver",
      },
      types: [
        { type: "Owner", name: "صاحب بار" },
        { type: "Carrier", name: "باربری" },
      ],
      statuses: [
        { id: 1, name: "فعال" },
        { id: 0, name: "غیرفعال" },
      ],
      pageSize: 30,
      currentPage: 1,
    };
  },
  computed: {
    gridColumns() {
      return [
        { title: "#", template: this.getTemplateID },
        { field: "name", title: "نام", width: "150px" },
        { field: "family", title: "نام خانوادگی", width: "150px" },
        { field: "national_code", title: "کد ملی", width: "100px" },
        { field: "phone", title: "شماره تماس", width: "100px" },
        { field: "username", title: "نام کاربری", width: "120px" },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
          width: 150,
        },
        { title: "سمت", field: "type", width: "100px" },
        {
          title: "وضعیت",
          template: (e) => this.statusText(e.is_active),
          width: "70px",
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
          width: 50,
        },
      ];
    },
  },
  mounted() {
    if (this.$acl.roles.find((e) => e === "carrier_test")) {
      this.isCarrier_test = true;
    }
    if (this.$acl.isSuperAdmin)
      Promise.all([this.getRoles()]).then((res) => {
        this.roles = res[0].data;
      });
  },
  methods: {
    statusText(e) {
      return e == 1
        ? "<span class='label label-primary'> فعال </span>"
        : "<span class='label label-danger'> غیرفعال </span>";
    },
    onEntitiesChange(_model) {
      this.getModels(_model).then((res) => {
        this.entities = res.data;
      });
    },
    getModels(_model) {
      let url = "";
      switch (_model) {
        case "Bar\\Model\\Owner":
          url = "owners";
          break;
        case "Bar\\Model\\Carrier":
          url = "carriers";
          break;
        case "Bar\\Model\\Driver":
          url = "drivers";
          break;
        default:
          url = "owners";
          break;
      }
      return this.$persistClient("get", url);
    },
    getLoads(categoryId) {
      return this.$persistClient("get", `loads?filter[parent]=${categoryId}`);
    },
    getVehicleTypes(categoryId) {
      return this.$persistClient(
        "get",
        `vehicle-types?filter[parent]=${categoryId}`
      );
    },
    getCityOrgin(stateId) {
      return this.$persistClient("get", `cities?filter[parent]=${stateId}`);
    },
    getCityDestination(stateId) {
      return this.$persistClient("get", `cities?filter[parent]=${stateId}`);
    },
    handleCreate(data) {
      this.isLoadingModal = true;

      this.$persistClient("post", "users", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.messages);

          this.createForm = {};

          this.loadData();
          this.$refs.createModal.reset();

          this.$toggleModal("#create-modal");
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    statusChangeModalAssistant() {
      $("#assistant-modal")
        .modal()
        .modal("toggle");
    },
 openPasswordModal(user) {
  console.log(user)
      this.isLoadingModal = true;
      this.selectedUser = user;

      const _this = this;
      setTimeout(function() {
        _this.isLoadingModal = false;
      }, 300);

      this.statusChangeModalPassword();
    },
    statusChangeModalPassword(user) {
      $("#password-modal")
        .modal()
        .modal("toggle");
},

    handleEdit(data) {
      this.isLoadingModal = true;

      this.$persistClient("patch", `users/${data.id}`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {};

          this.loadData();
          this.$refs.editModal.reset();

          this.$toggleModal("#edit-modal");
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `users?include=roles,model&page=${this.currentPage}&page_size=${this.pageSize}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.filters, "&");
      this.$persistClient("get", url)
        .then((res) => {
          this.users = res.data;
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    deleteUser(user) {
      this.$alert(
        "question",
        `آیا از حذف کاربر  ( ${user.name} ) اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `users/${user.id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
     expireToken(user) {
      this.$alert(
        "question",
        `آیا از پایان نشست کاربر  ( ${user.name} ) اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `users/${user.id}/revokeUserTokens`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    statusChangeModalEdit() {
      $("#edit-modal").modal({
        keyboard: true,
        show: true,
      });
    },
    statusChangeModalCreate() {
      $("#create-modal").modal({
        keyboard: true,
        show: true,
      });
    },
    statusChangeModalRoleEdit() {
      this.$toggleModal("#edit-role");
    },
    gridCommands() {
      let commands = [];
      /* if (
        this.$acl.isSuperAdmin ||
        this.isCarrier_test ||
        this.$acl.can("update", "ussssssers")
      ) {*/
      commands.push({
        text: "view",
        click: this.showActions,
        template:
          "<a role='button' class='k-button k-button-icontext k-grid-view'><span class='fas fa-ellipsis-v' style='color:rgb(20 169 217)'></span></a>",
      });
      //  }
      return commands;
    },
    showActions(e) {
      e.originalEvent.stopPropagation();

      const request = this.$refs.grid.getSelectedGridRow(e);

      this.$refs.contextMenu.init(e.originalEvent, request);
    },
    status(user) {
      this.$alert(
        "question",
        `آیا از تغییر وضعیت این کاربر اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          let status = {
            is_active: !user.is_active,
          };
          this.$persistClient("patch", `users/${user.id}`, status)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    edit(user) {
      this.isLoadingGrid = true;
      var _this = this;
      let data = user;
      data = {
        id: data.id,
        name: data.name,
        family: data.family,
        national_code: data.national_code,
        phone: data.phone,
        username: data.username,
        postal_code: data.postal_code,
        address: data.address,
        model_type: data.model_type,
        model_id: data.model_id,
        password: data.password,
      };
      if (this.$acl.isSuperAdmin) {
        this.getModels(data.model_type).then((res) => {
          this.entities = res.data;
          setTimeout(() => {
            _this.updateForm = data;
            _this.statusChangeModalEdit();
            this.isLoadingGrid = false;
          }, 500);
        });
      } else {
        setTimeout(() => {
          _this.updateForm = data;
          _this.statusChangeModalEdit();
          this.isLoadingGrid = false;
        }, 500);
      }
    },
    roleEdit(user) {
      const _this = this;
      this.isLoadingmodal = true;
      let role = collect(user.roles)
        .pluck("id")
        .toArray();
      role = role.filter(function(e) {
        return e != null;
      });
      setTimeout(function() {
        _this.roleData = { user_id: user.id, role_name: role };
        _this.isLoadingModal = false;
        _this.statusChangeModalRoleEdit();
      }, 300);
    },
    assistant(user) {
      this.isLoadingModal = true;
      let owner = user;
      this.owner = owner;
      const _this = this;
      setTimeout(function() {
        _this.$refs.assistant.readData();
        _this.isLoadingModal = false;
      }, 300);
      this.statusChangeModalAssistant();
    },
    getRoles() {
      return this.$persistClient("get", "roles");
    },
    handleEditRole(e) {
      this.isLoadingModal = true;
      let data = {
        role_name: e.role_name,
      };
      this.$persistClient("patch", `users/${e.user_id}`, data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
          this.statusChangeModalRoleEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
      if (!this.showFilters) {
        this.filters = {
          none_type: "Driver",
        };
        this.loadData();
        this.resetFilter();
      }
    },
changePassword(e) {
  this.isLoadingModal = true;
  let data = {
    new_password: e.new_password,
    confirm_password: e.confirm_password,
  };

  this.$persistClient("patch", `users/${e.user_id}/change-password`, data)
    .then((res) => {
      this.$izitoast("success", "موفق", res.data.message || "رمز عبور با موفقیت تغییر کرد");
      this.loadData();
      this.statusChangeModalPassword(); 
    })
    .finally(() => {
      this.isLoadingModal = false;
    });
},



    salonsOfUser(user) {
      this.propsDriver = {
        id: user.id,
        full_name: user.full_name,
      };
      this.$toggleModal("#salons-modal");
    },
    userSearch: _.debounce(function() {
      this.loadData();
    }, 1000),
    resetFilter() {
      this.$refs.typeDropDown.emptyKendo();
      this.$refs.statusDropDown.emptyKendo();
    },
    handleDownloadDocuments(documentsUrl) {
      window.open(documentsUrl, "_blank");
    },
  },
};
</script>
<style scoped>
.label {
  font-family: "iranyekan";
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
